import {API} from '../API';

export class NoteService {

  async saveNote(message, data) {
    return (await API.getConnection())
      .post(`inbox/${message.id}/notes`, data)
      .then(response => response.data.data)
      .catch(error => API.handleError(error));
  }
}
